// Override Settings
var bcSfSearchSettings = {
    search: {
        suggestionMode: 'test',
        //suggestionPosition: 'left'
      	suggestionBlocks: [
          { type: 'suggestions', label: 'Suggestions', status: 'active', number: 3 },
          { type: 'collections', label: 'Collections', status: 'active', number: 2 },
          { type: 'pages', label: 'Pages', status: 'active', number: 2 },
          { type: 'products', label: 'Products', status: 'active', number: 3 },
        ],
    }
};

function sortUnique(arr) {
  arr.sort();
  var last_i;
  for (var i=0;i<arr.length;i++)
    if ((last_i = arr.lastIndexOf(arr[i])) !== i)
      arr.splice(i+1, last_i-i);
  return arr;
}

 
  
  
// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
};

BCSfFilter.prototype.buildSuggestionProductList = function(searchTerm, itemData, ul, itemInfo, suggestionData) {
    var self = this;
    var result = '';
    // Buid Header
    result += this.buildSuggestionHeader(itemInfo['label'], 'product');
    // Build Did you mean
    var dym = this.buildSuggestionDidYouMean(searchTerm, suggestionData, ul);
    if (dym != '') {
        result += '<li class="' + this.class.searchSuggestionItem + ' bc-sf-search-suggestion-dym" aria-label="Did you mean">' + dym + '</li>';
    }
    
    // Build content
    if (Object.keys(itemData).length > 0) {
        // var count = 0;   
        var k;
        var itemDataLength = itemData.length; 
        for (k = 0; k < itemDataLength; k++) {
            // if (count < itemInfo['number']) {
            var product = itemData[k];
            // Get product attributes
            var variant = product.variants.find(function(e){return e.sku === searchTerm;});
            var productTitle = this.customizeSuggetionProductTitle(product['title'], searchTerm, itemData);
            productTitle = this.highlightSuggestionResult(productTitle, searchTerm);
            var productUrl = this.buildProductItemUrl(product, false);
            var productThumb = product['images_info'].length > 0 ? this.optimizeImage(product['images_info'][0]['src'], '200x') : bcSfFilterConfig.general.no_image_url;
            if (typeof variant != 'undefined') {
                productUrl += '?variant=' + variant.id;
            }
            var productSku = product.skus !== null && product.skus.length > 0 ? product['skus'][0] : '';
            // Get custom class / attribute
            var searchSuggestionClass = this.class.searchSuggestion;
            var newTabAttr = this.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';
            result += '<li class="' + this.class.searchSuggestionItem + ' ' + this.class.searchSuggestionItem + '-product" aria-label="' + this.escape(itemInfo['label']) + ': ' + this.escape(product['title']) + '">';
            result += '<a href="' + productUrl + '" ' + newTabAttr + '>';
            // Build Left column
            if (this.getSettingValue('search.showSuggestionProductImage')) {
                result += '<div class="' + searchSuggestionClass + '-left"><img src="' + productThumb + '" /></div>';
            }
            // Build Right column
            result += '<div class="' + searchSuggestionClass + '-right">';
            result += '<div class="' + searchSuggestionClass + '-product-title">' + productTitle + '</div>';
            if (this.getSettingValue('search.showSuggestionProductSku')) {
                result += '<div class="' + searchSuggestionClass + '-product-sku">SKU: ' + productSku + '</div>';
            }
            if (this.getSettingValue('search.showSuggestionProductVendor')) {
              if(product['vendor'] != 'Oneida'){
                result += '<div class="' + searchSuggestionClass + '-product-vendor">' + product['vendor'] + '</div>';
              }
             }
              
            result += this.buildSuggestionProductPrice(product);
            result += '</div>'; // End Right column
            result += '</a>'; // End a
            result += '</li>'; // End li
            // count++;
            // } else break;
        }
    }
    return result;
};

BCSfFilter.prototype.buildSuggestionProductPrice = function(a) {
    var variantPriceArr = []
    a.variants.forEach(function(_variant, index) {
      if(_variant.inventory_quantity > 0) {
        variantPriceArr.push(parseFloat(_variant.price))
      }
    });
    if(variantPriceArr.length < 1) {
        variantPriceArr.push(parseFloat(a.price_min))
    }
    variantPriceArr = sortUnique(variantPriceArr);
    variantPriceArr.sort(function(a, b){return a-b});
    
    this.prepareSuggestionProductPriceData(a);
    var b = a.compare_at_price_min > variantPriceArr[0],
        c = this.formatMoney(100 * variantPriceArr[0]),
        d = this.formatMoney(100 * a.compare_at_price_min);
    this.getSettingValue("search.removePriceDecimal") && (c = this.removeDecimal(c), d = this.removeDecimal(d));
    var e = "";
    return this.getSettingValue("search.showSuggestionProductPrice") && (e += '<div class="' + this.class.searchSuggestion + '-product-price">', b && this.getSettingValue("search.showSuggestionProductSalePrice") ? (e += "<s>" + d + "</s>  ", e += '<span class="bc-sf-product-sale-price">' + c + "</span>") : e += '<span class="bc-sf-product-regular-price">' + c + "</span>", e += "</div>"), e
}

BCSfFilter.prototype.buildSearchBox = function(id) {
    // Customize Search box before building Auto suggestion
    this.beforeBuildSearchBox(id);
    var self = this;
    if (jQ(id).length > 0) {
        var appendToSelector;
        if (self.isSuggestionStyle2()) {
            appendToSelector = self.getSettingValue('search.suggestionStyle2MainContainerSelector') || 'header:first';
        } else {
            appendToSelector = 'body';
        }
        var queryValue = this.currentTerm = getParam(this.searchTermKey);
        jQ(id).val(queryValue);
        jQ(id)
            .autocomplete({
                appendTo: appendToSelector,
                minLength: self.getSettingValue('search.suggestionMinLength'),
                delay: 200,
                source: function(request, response) {
                    window.suggestionCallback = response;
                    self.currentTerm = request.term;
                    var term = (request.term).trim().replace(/\s+/g, ' ');
                    if (term != '') {
                        self.requestSuggestion(term, id);
                    }
                },
                classes: {
                    'ui-autocomplete': self.class.searchSuggestion
                },
                // position: {my: "left+0 top+12"},
                response: function(ev, ui) {
                    // Prepare data
                    var result = ui.content;
                    var searchTerm = getValueInObjectArray('query', result);
                    var eventType = getValueInObjectArray('event_type', result);
                    var suggestQuery = getValueInObjectArray('suggest_query', result);
                    var localCache = getValueInObjectArray('local_cache', result);
                    var redirect = getValueInObjectArray('redirect', result);
                    // Cache
                    if (Object.keys(self.suggestionCache).length == 25) self.suggestionCache = {};
                    if (!(searchTerm in self.suggestionCache) && eventType != 'suggest_dym') {
                        self.suggestionCache[searchTerm] = result;
                    }
                    // Send another request to get the product list of suggest_query
                    if (suggestQuery != '' && eventType == 'suggest' && !localCache) {
                        // self.getSuggestionData(suggestQuery, 0, 'suggest_dym', searchTerm);
                    }
                    // Check for search redirect after receiving the API response
                  	self.checkForSearchRedirect(id, redirect);
                    // Hide loading after receiving the API response
                    self.hideSuggestionLoading(id);
                },
                focus: function(ev, ui) {
                    return false;
                },
                open: function(ev, ui) {
                    self.openSuggestionEvent(id, ev);
                },
                close: function(ev, ui) {
                    self.closeSuggestionEvent(id, ev);
                },
                select: function(ev, ui) {
                    return false;
                }
            })
            // Add some additional attributes
            .addClass(self.class.searchBox)
            .attr('data-search-box', id);
        // Build Auto Suggestion
        jQ(id).autocomplete('instance')._renderMenu = function(ul, data) {
            ul.attr('data-search-box', id);
            return self.buildSuggestion(this.term, data, ul, id);
        };
        // Resize Suggestion box
        jQ(id).autocomplete('instance')._resizeMenu = function() {
            var suggestionElement = this.menu.element;
            var searchElement = this.element;
            self.buildStyleSuggestion(suggestionElement, searchElement, id);
        };
        // Custom some functions of Search menu widget
        self.customSearchMenuWidget(id);
        // Close Suggestion box when click outside autocomplete region
        self.clickOutsideSuggestionEvent(id);
    }
    // Set open position of Suggestion box
    this.setSuggestionPosition(id);
    this.buildSearchBoxEvent(id);
    this.afterBuildSearchBox(id);
};

BCSfFilter.prototype.buildSuggestion = function(searchTerm, suggestionData, ul, searchBoxId) {
  var self = this,
    searchTerm = this.escape(searchTerm),
    ulSelector = jQ(ul),
    result = '',
    isAllEmpty = getValueInObjectArray('all_empty', suggestionData);
  // Show suggestion wrapper
  ulSelector.closest('.' + self.class.searchSuggestionWrapper).show();
  // Check is_empty
  // If true: Nothing found
  if (isAllEmpty) {
    var hasRedirect = getValueInObjectArray('redirect', suggestionData);
    // If have search redirect and no result, hide the search suggestion
    if (hasRedirect) {
      ulSelector.closest('.' + self.class.searchSuggestionWrapper).hide();
      // Otherwise build no result block
    } else {
      result += self.buildSuggestionNoResult(searchTerm, ul);
      ulSelector.append(result);
    }
  }
  // Otherwise: Start buidling the content of Suggestion
  else {
    // Build main content
    var blocks = self.getSettingValue('search.suggestionBlocks');
    // Update the label of suggestion blocks by translation label
    blocks = this.updateSuggestionBlockLabel(blocks);
    // Style2
    if (self.isSuggestionStyle2() && blocks[0].type != "products") {
      var indexProducts = blocks.findIndex(function(block) {
        return block.type == 'products';
      });
      var tempProducts = blocks[indexProducts];
      blocks.splice(indexProducts, 1);
      // if suggestionStyle2ReverseProductBlock is enabled
      if (self.getSettingValue('search.suggestionStyle2ReverseProductBlock')) {
        blocks.push(tempProducts);
      } else {
        blocks.unshift(tempProducts);
      }
    }
    var blocksLength = blocks.length;

    var html = '';
    html += '<div class="bc-sf-search-suggestion-group-wrapper-left">'
    var k;
    for (k = 0; k < blocksLength; k++) {
      var suggestionItemInfo = blocks[k];
      if (suggestionItemInfo.hasOwnProperty('status') && suggestionItemInfo['status'] == 'active') {
        var index = self.findIndexArray(suggestionItemInfo['type'], suggestionData, 'key');
        if (index > -1 && suggestionData[index].hasOwnProperty('values')) {
          var m = suggestionData[index];
          var t = m.values.length > 0 ? '' : ' style="display: none;"';
          var content = '';
          if(suggestionItemInfo['type'] != 'products') {
              var suggestionItemData = suggestionData[index];
              content = '<li class="bc-sf-search-suggestion-group" data-group="' + suggestionItemInfo['type'] + '" aria-label="' + blocks[k]['label'] + '" ' + t + '><ul>';
              switch (suggestionItemInfo['type']) {
                case 'suggestions':
                  content += self.buildSuggestionPopular(searchTerm, suggestionItemData['values'], ul, suggestionItemInfo, suggestionData);
                  break;
                case 'pages':
                  content += self.buildSuggestionPage(searchTerm, suggestionItemData['values'], ul, suggestionItemInfo, suggestionData);
                  break;
                case 'collections':
                  content += self.buildSuggestionCollection(searchTerm, suggestionItemData['values'], ul, suggestionItemInfo, suggestionData);
                  break;
              }
              content += '</ul></li>';
          }
          html += content;
          // ulSelector.append(content);
        }
      }
    }
    html += '</div>';
    html += '<div class="bc-sf-search-suggestion-group-wrapper-right">'
    for (k = 0; k < blocksLength; k++) {
      var suggestionItemInfo = blocks[k];
      if (suggestionItemInfo.hasOwnProperty('status') && suggestionItemInfo['status'] == 'active') {
        var index = self.findIndexArray(suggestionItemInfo['type'], suggestionData, 'key');
        if (index > -1 && suggestionData[index].hasOwnProperty('values')) {
          var suggestionItemData = suggestionData[index];
          var content = '';
          if(suggestionItemInfo['type'] == 'products') {
            content = '<li class="bc-sf-search-suggestion-group" data-group="' + suggestionItemInfo['type'] + '" aria-label="' + blocks[k]['label'] + '"><ul>'
            content += self.buildSuggestionProductList(searchTerm, suggestionItemData['values'], ul, suggestionItemInfo, suggestionData);
            content += '</ul></li>';   
          }
          html += content;
          // ulSelector.append(content);
        }
      }
    }
    // Build 'View All'
    if (getValueInObjectArray('suggest_query', suggestionData) === '') {
      var viewAllContent = self.buildSuggestionViewAll(searchTerm, suggestionData, ul);
      html += viewAllContent;
      // ulSelector.append(viewAllContent);
    }
    html += '</div>';
    ulSelector.append(html);
  }
  // Add autocomplete item data for navigation
  ulSelector.find('.' + self.class.searchSuggestionItem + '[data-label]').each(function() {
    var $this = jQ(this);
    var label = $this.data('label') || '';
    var value = $this.data('value') || '';
    if (value !== '') {
      $this.data('ui-autocomplete-item', { label: label.toString(), value: value }).addClass('bc-ui-item');
    }
  });
  // Wrapper
  self.buildSuggestionWrapper(ul, searchBoxId);
};